import { type ReactNode } from 'react';

import { Link } from 'react-router';

import { useAppDispatch, useAppSelector } from 'dux/app/hooks';

import { Button } from 'Components/LegacyButton';

import { productsSlugs } from 'constants/products';

import { trackPreselect } from 'dux/tracking/actions';
import { getStylingGelCTAProps } from 'dux/userFlows/selectors';

const appendToUrl = (url: string, append: string) => {
  return `${url}${url.includes('?') ? '&' : '?'}${append}`;
};

type CTAProps = {
  children?: ReactNode;
  className?: string;
  dataFrom?: string;
  label?: string;
  fullWidth?: boolean;
  variant?: 'vert' | 'underlinedBlack' | 'add' | 'vert' | 'whiteFull';
  classes?: Record<string, string>;
  dataTestId?: string;
};

export const CTA = ({
  children,
  classes,
  dataTestId,
  className,
  dataFrom,
  label,
  fullWidth,
  variant,
}: CTAProps) => {
  const ctaProps = useAppSelector(getStylingGelCTAProps);
  const dispatch = useAppDispatch();

  const onClick = () => {
    dispatch(
      // @ts-expect-error trackPreselect is not typed yet
      trackPreselect({
        productSlug: productsSlugs.STYLING_GEL,
        locationId: 'landing-page_styling-gel',
      }),
    );
  };

  return (
    <Button
      classes={classes}
      className={className}
      Component={Link}
      data-click={ctaProps.dataClick}
      data-from={dataFrom}
      data-testid={dataTestId}
      fullWidth={fullWidth}
      onClick={onClick}
      to={dataFrom ? `${appendToUrl(ctaProps.to, `data-from=${dataFrom}`)}` : ctaProps.to}
      variant={variant}
    >
      {children ?? ctaProps.ctaTemplate(label ?? 'styling gel')}
    </Button>
  );
};
